import { Stack, Typography, useTheme } from '@mui/material'
import React from 'react'

const EmailHelp: React.FC = () => {
    const theme = useTheme()
    return (
        <Stack width='476px' bgcolor={theme.palette.background.default} p={3}>
            <Typography variant='h6'>Nápověda</Typography>
            <Typography variant='body2'>Seznam proměnných do textu zprávy:</Typography>
            <Typography variant='body2'>{'{{eventName}}'} ... název události</Typography>
            <Typography variant='body2'>{'{{invoiceLink}}'} ... url faktury</Typography>
            <Typography variant='body2'>{'{{surveyLink}}'} ... url dotazníku</Typography>
            <Typography variant='body2'>{'{{startsAt}}'} ... datum a čas začátku</Typography>
            <Typography variant='body2'>{'{{endsAt}}'} ... datum a čas konce</Typography>
            <Typography variant='body2'>{'{{address}}'} ... adresa</Typography>
            <Typography variant='body2'>{'{{contact}}'} ... kontakt</Typography>
            <Typography variant='body2'>{'{{productList}}'} ... služby/atrakce</Typography>
            <Typography variant='body2'>{'{{profit}}'} ... kalkulace</Typography>
        </Stack>
    )
}

export default EmailHelp
